<!-- Общий каркас одного этапа мастера осмотра ТС. -->
<template>
  <div class="inspection-step" :class="{ 'inspection-step--center': centered }">
    <div v-if="title || description || $slots.heading" class="inspection-step__heading">
      <slot name="heading">
        <h1 v-if="title">{{ title }}</h1>
        <p v-if="description">{{ description }}</p>
      </slot>
    </div>

    <slot />

    <div v-if="$slots.actions" class="inspection-step__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: "VehicleInspectionStepLayout",
  props: {
    title: { type: String, default: "" },
    description: { type: String, default: "" },
    centered: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.inspection-step {
  min-height: 100%;
  padding: 12px 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
}

.inspection-step--center {
  justify-content: center;
}

.inspection-step__heading {
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
}

.inspection-step__heading :deep(h1) {
  margin: 0;
  font-size: 26px;
  line-height: 1.25;
}

.inspection-step__heading :deep(p) {
  margin: 0;
  font-size: 16px;
  line-height: 1.45;
  color: color-mix(in srgb, var(--color-dark) 65%, var(--color-light));
}

.inspection-step__actions {
  width: 100%;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.inspection-step__actions :deep(.btn) {
  width: 100%;
}

@media (min-width: 768px) {
  .inspection-step {
    width: min(100%, 720px);
    margin: 0 auto;
  }
}
</style>
